// PdfCompressor.js
import React, { useState } from 'react';
import { PDFDocument } from 'pdf-lib';
import './Dashboard.css';
import { ReactComponent as IconCompress } from './icons/compress.svg';

const PdfCompressor = () => {
  const [compressedUrl, setCompressedUrl] = useState(null);

  const handleCompress = async (event) => {
    const file = event.target.files[0];
    if (!file || file.type !== 'application/pdf') return;

    const arrayBuffer = await file.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);

    // Remove metadata
  pdfDoc.setTitle('');
  pdfDoc.setAuthor('');
  pdfDoc.setSubject('');
  pdfDoc.setKeywords([]);
  pdfDoc.setProducer('');
  pdfDoc.setCreator('');
  // Only set creation/modification date if you have a valid Date object
 pdfDoc.setCreationDate(new Date()); // Uncomment to set to now
 pdfDoc.setModificationDate(new Date()); // Uncomment to set to now

    // draw a simple border on every page before saving
    try {
      const pages = pdfDoc.getPages();
      pages.forEach((page) => {
        const { width, height } = page.getSize();
        const borderMargin = 10;
        // draw rectangle border
        try {
          page.drawRectangle({
            x: borderMargin / 2,
            y: borderMargin / 2,
            width: width - borderMargin,
            height: height - borderMargin,
            borderWidth: 0.5,
          });
        } catch (e) {
          // ignore if drawRectangle is not supported on this page object
        }
      });
    } catch (e) {
      // ignore page drawing errors
    }

    // Save with object streams for minimal file size
    const compressedBytes = await pdfDoc.save({ useObjectStreams: true });
    const blob = new Blob([compressedBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    setCompressedUrl(url);
  };

  return (
    <div className="pdf-compressor-container">
      <div style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 6 }}>
        <h2>PDF Compressor</h2>
        <input id="compress-upload" type="file" accept="application/pdf" onChange={handleCompress} style={{display:'none'}} />
        <label htmlFor="compress-upload" className="tool-button"><IconCompress aria-hidden="true"/> Choose PDF</label>
        {compressedUrl && (
          <div style={{ marginTop: '20px' }}>
            <a className="tool-button" href={compressedUrl} download="compressed.pdf"><IconCompress aria-hidden="true"/> Download Compressed PDF</a>
          </div>
        )}
      </div>

      <div>
        <div className="content">

  <h2>Compress PDF: Reduce File Size Without Losing Quality</h2>

  <p>
    Large PDF files can be difficult to share, upload, or store—especially when they 
    contain high-resolution images or lengthy documents. The Compress PDF tool helps 
    you shrink file sizes efficiently while keeping text sharp and images clear.
  </p>

  <p>
    Whether you're emailing a report, uploading documents to a website, or freeing up 
    storage space, PDF compression ensures your file remains professional and easy to 
    work with.
  </p>

  <h3>Why Compress a PDF?</h3>

  <ul>
    <li>Reduce file size for faster uploads and downloads</li>
    <li>Meet size limits for email or online forms</li>
    <li>Save storage space on your device</li>
    <li>Optimize PDFs with many images or scanned pages</li>
    <li>Improve performance on slower devices or networks</li>
  </ul>

  <h3>How PDF Compression Works</h3>

  <h4>1. Upload Your PDF</h4>
  <p>
    Start by selecting the PDF file you want to compress. The system analyzes 
    images, fonts, and embedded objects to determine the best compression strategy.
  </p>

  <h4>2. Choose Compression Level</h4>
  <p>
    Select the quality level that works best for your needs:
  </p>
  <ul>
    <li><strong>High Compression</strong> – Smallest file size, suitable for web uploads.</li>
    <li><strong>Balanced Compression</strong> – Best mix of quality and size.</li>
    <li><strong>Low Compression</strong> – Highest quality with moderate size reduction.</li>
  </ul>

  <h4>3. Optimization Process</h4>
  <p>
    The compression engine reduces image resolution, removes unnecessary metadata, 
    optimizes embedded fonts, and cleans redundant elements—all without altering 
    essential content.
  </p>

  <h3>Your Final Compressed PDF</h3>
  <p>
    Once the process is complete, you’ll receive a significantly smaller PDF that 
    still maintains readability and visual clarity. It's ready to share, upload, 
    store, or archive with confidence.
  </p>

</div>

      </div>
    </div>
  );
};

export default PdfCompressor;
// src/components/PdfCompressor.js